import { VideoPlaylist } from '@/components/AthleteProfile/AthleteProfileV2/ProfileSections/Films/VideoPlaylist/Objects/VideoPlaylist.js';

export function loadAthleteSuccess(state, data) {
    state.user = {
        ...state.user,
        ...data,
    };

    state.hasRetrievedBasicInfo = true
}

export function clearAthlete(state) {
    state.user = {}
    state.hasRetrievedBasicInfo = false
}

export function loadAthleteEventsSuccess(state, events) {
    state.user = { ...state.user || {}, events };
}

export function loadAthleteVideosSuccess(state, videos) {
    state.user = { ...state.user || {}, videos };
}

export function favoriteStart(state, tentativeFavorite) {
    state.isTakingEvaluationAction = true
    state.actionTimestamp = new Date().getTime()

    state.user.favoritesReceived = [tentativeFavorite]
    state.user.skips = []
}

export function favoriteSuccess(state, favorite) {
    state.user.favoritesReceived = [favorite]
    state.user.skips = []
    state.isTakingEvaluationAction = false
}

export function favoriteFailure(state, { skips }) {
    state.isTakingEvaluationAction = false
    state.user.skips = skips
}

export function skipStart(state, tentativeSkip) {
    state.isTakingEvaluationAction = true
    state.actionTimestamp = new Date().getTime()

    state.user.skips = [tentativeSkip]
    state.user.favoritesReceived = []
}

export function skipSuccess(state, skip) {
    state.user.skips = [skip]
    state.user.favoritesReceived = []
    state.isTakingEvaluationAction = false
}

export function skipFailure(state, { favorites }) {
    state.isTakingEvaluationAction = false
    state.user.favoritesReceived = favorites
}

export function feedbackRequestStart(state) {
    state.isSendingFeedbackRequest = true
}

export function feedbackRequestSuccess(state) {
    state.isSendingFeedbackRequest = false
}

export function feedbackRequestFailure(state) {
    state.isSendingFeedbackRequest = false
}

export function setIsModal(state, value) {
    state.isModal = value;
}

export function setShowNewAthleteProfile(state, value) {
    state.showNewAthleteProfile = value;
}

export function setShowSecondaryNavbar(state, value) {
    state.showSecondaryNavbar = value;
}

export function removePreCommitment(state) {
    state.user.commitment = null;
}

export function setShowMultiPlaylists(state, value) {
    state.showMultiPlaylists = value;
}

export function setShowIsolationEffects(state, value) {
    state.showIsolationEffects = value;
}

export function setVideoPlaylists(state, playlists) {
    state.videoPlaylists = playlists.map((playlist) => VideoPlaylist.fromGraphQL(playlist));
}

export function setSkills(state, skills) {
    state.skills = skills;
}

export function setVideoPlaylistPlaying(state, playlist) {
    state.videoPlaylistPlaying = playlist ? VideoPlaylist.fromGraphQL(playlist) : null;
}

export function setShareLinkVideo(state, video) {
    state.shareLinkVideo = video;
}